import React, { useContext } from 'react';
import { string, func } from 'prop-types';
import { AddStorageDataContext } from 'context/AddStorageContext';
import styled from 'styled-components';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const EditIconDefault = `${CDN_URL}common/icon-edit-default-lg.svg`;
const EditIconHover = `${CDN_URL}common/icons-edit-selected-lg.svg`;

const ReviewStyle = styled.div`
	width: 100%;
	height: 175px;
	margin-bottom: 50px;

	.ScrollbarsCustom-Track {
		right: -15px !important;
		top: 0px !important;
	}
	.ScrollbarsCustom-ThumbY {
		background-color: ${props => props.theme.storage} !important;
		width: 6px !important;
	}
	.ScrollbarsCustom-TrackY:before {
		border-left: none;
	}
	.ScrollbarsCustom-TrackY {
		background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
		width: 6px !important;
	}

	.section-details-wrapper {
		display: flex;
		margin-bottom: 10px;
		.user-details,
		.dc-locations-details,
		.badge-details {
			width: 100%;
		}
		.section-details {
			width: 90%;
			margin-bottom: 20px;
		}

		.dc-locations-details {
			width: 100%;
			margin-bottom: 20px;
		}
		.detail-row {
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			height: 20px;
			margin-bottom: 10px;
			.label {
				margin-top: 2px;
				width: 60px;
			}
			.value {
				width: 200px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				margin-left: 10px;
				display: flex;
				.location {
					margin-right: 5px;
				}
			}
			.value-wl {
				width: 110px;
				white-space: wrap;
				overflow: hidden;
				text-overflow: ellipsis;
				margin-left: 10px;
				display: flex;
			}
		}
		.edit-icon {
			cursor: pointer;
			img {
				width: 15px;
				height: 15px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 230px;
		margin-bottom: 50px;

		.ScrollbarsCustom-Track {
			right: -24px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.storage} !important;
			width: 8px !important;
		}

		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 8px !important;
		}

		.section-details-wrapper {
			margin-bottom: 10px;

			.section-details {
				width: 90%;
				margin-bottom: 20px;
			}

			.dc-locations-details {
				margin-bottom: 20px;
			}
			.detail-row {
				height: 20px;
				margin-bottom: 10px;
				.label {
					margin-top: 4px;
					width: 80px;
				}
				.value {
					width: 275px;
					margin-left: 10px;
					display: flex;
					.location {
						margin-right: 5px;
					}
				}
				.value-wl {
					width: 125px;
					margin-left: 10px;
				}
			}
			.edit-icon {
				img {
					width: 15px;
					height: 15px;
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 400px;
		margin-bottom: 50px;
		.ScrollbarsCustom-Track {
			right: -24px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.storage} !important;
			width: 10px !important;
		}

		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 10px !important;
		}

		.section-details-wrapper {
			margin-bottom: 10px;

			.section-details {
				width: 90%;
				margin-bottom: 30px;
			}

			.dc-locations-details {
				margin-bottom: 30px;
			}
			.detail-row {
				height: 20px;
				margin-bottom: 15px;
				.label {
					margin-top: 2px;
					width: 120px;
				}
				.value {
					width: 400px;
					margin-left: 10px;
					display: flex;
					.location {
						margin-right: 5px;
					}
				}
				.value-wl {
					width: 150px;
					margin-left: 10px;
				}
			}
			.edit-icon {
				img {
					width: 25px;
					height: 25px;
				}
			}
		}
	}
`;

function getEditIcon(activePage, setActivePageIndex) {
	return (
		<div className='edit-icon'>
			<img
				src={EditIconDefault}
				onMouseOver={e => {
					e.currentTarget.src = EditIconHover;
				}}
				onMouseOut={e => {
					e.currentTarget.src = EditIconDefault;
				}}
				alt='edit-icon'
				onClick={() => setActivePageIndex(activePage)}
			/>
		</div>
	);
}

export const ShareReviewScreen = ({ setActivePageIndex }) => {
	const { inputs } = useContext(AddStorageDataContext);
	const ips = inputs?.whitelist?.ips;

	return (
		<ReviewStyle>
			<ScrollView>
				<div className='section-details-wrapper'>
					<div className='section-details'>
						<div className='detail-row'>
							<div className='label labels21'>Primary Location:</div>
							<div className='value body10'>{inputs.primaryLocation}</div>
						</div>
					</div>
					{getEditIcon(2, setActivePageIndex)}
				</div>
				{inputs?.redundancy && (
					<div className='section-details-wrapper'>
						<div className='section-details'>
							<div className='detail-row'>
								<div className='label labels21'>Secondary Location:</div>
								<div className='value body10'>{inputs.secondaryLocation}</div>
							</div>
						</div>
						{getEditIcon(4, setActivePageIndex)}
					</div>
				)}
				<div className='section-details-wrapper'>
					<div className='section-details'>
						<div className='detail-row'>
							<div className='label labels21'>Share Access:</div>
							<div className='value body10'>{inputs.access}</div>
						</div>
					</div>
					{getEditIcon(5, setActivePageIndex)}
				</div>
				<div className='section-details-wrapper'>
					<div className='section-details'>
						<div className='detail-row'>
							<div className='label labels21'>Share Name:</div>
							<div className='value body10'>{inputs.name}</div>
						</div>
					</div>
					{getEditIcon(1, setActivePageIndex)}
				</div>
				<div className='section-details-wrapper'>
					<div className='section-details'>
						<div className='detail-row'>
							<div className='label labels21'>Whitelist:</div>
							{ips &&
								ips.map(ip => (
									<div className='value-wl body10' key={ip?.ip}>
										{ip?.ip}
									</div>
								))}
						</div>
					</div>
					{getEditIcon(6, setActivePageIndex)}
				</div>
			</ScrollView>
		</ReviewStyle>
	);
};

ShareReviewScreen.propTypes = {
	setActivePageIndex: func.isRequired,
	type: string,
};

ShareReviewScreen.defaultProps = {
	type: '',
};
